<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="summary vh-for-mobile" :data-variant="variant" @click="closeBanner" @transitionend="hasInfoBox">

      <div class="wrapper">

        <div v-if="config.shortText" class="summary__shortText" v-html="config.shortText"></div>

        <div v-if="config.fullText" class="summary__fullText" v-html="config.fullText"></div>

        <div v-if="config.recap" v-for="(item, index) in config.recap" :data-status="checkIndex(index)"
             class="summary__content">
          <div class="summary__content__header">{{item.title}}</div>
          <div class="summary__content__body">
            <div v-for="row in item.captions" class="summary__content__row">
              <span v-if="row.sub" v-html="row.sub"></span>
              <p v-if="row.main" v-html="row.main"></p>
            </div>
          </div>
        </div>

        <div v-if="config.answers" class="summary__confirm">
          <div v-for="answer in config.answers"
               :class="{'summary__confirm__btn': true, 'is-disabled': answer.disabled}"
               @click="retrieveNextStep(config.id, answer.id, false)">
            <img :src="answer.icon" alt="">
            <span class="summary__confirm__btn__span">{{answer.text}}</span>
          </div>
        </div>

        <div v-if="item.images" v-for="item in config.recap" class="summary__image">
          <div v-for="img in item.images" class="summary__image__block">
            <img :src="img" :alt="config.shortText"/>
          </div>
        </div>

        <transition name="fadeFromBottom" mode="out-in">
          <div v-if="hasBox" v-show="hasInfo" class="summary__info" @click.stop>
            <h4 v-if="config.info.title" v-html="config.info.title"></h4>
            <p v-if="config.info.subtitle" v-html="config.info.subtitle"></p>
          </div>
        </transition>

      </div>

    </div>
  </transition>


</template>

<script>

  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false,
        hasBox: false
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    computed: {
      hasOverlay(){
        return this.config.info && this.config.info.type == 'overlay';
      }
    },
    methods: {
      closeBanner(){
        var vm = this;
        vm.hasInfo = false;
        setTimeout(function () {
          vm.hasBox = false;
        }, 250);
      },
      hasInfoBox(){
        var vm = this;
        if (vm.config.info) {
          vm.hasInfo = true;
        }
      },
      checkIfOverflow(){
        var vm = this;
        var viewHeight = $('.summary').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.summary').addClass('has-overflow');
        }
      },
      checkIndex(idx){
        var vm = this;
        var currentIndex = vm.config.currentIndex;
        if (currentIndex != undefined) {
          if (idx < currentIndex) {
            return 'btn-prev';
          }
          else if (idx > currentIndex) {
            return 'btn-next';
          }
          else {
            return 'btn-current';
          }
        }
      },
      openInfoOverlay(){
        var vm = this;
        if (vm.config.info.type == 'overlay') {
          vm.$emit('open-overlay', vm.config.info);
        }
      },
      beforeEnter(){
        $('.summary__answers__item').addClass('slideLeft-enter');
      },
      enter(){
        $('.summary__answers__item').removeClass('slideLeft-enter');
      },
      leave(){
      },
      afterLeave(){
      },
      updateProps(){
        //Update component data when component is mounted or updated
        var vm = this;
        vm.config = vm.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          vm.$forceUpdate();
        }
      },
      retrieveNextStep(summaryId, answerId, isDisabled){
        if (!isDisabled) {
          // Make AJAX call to retrieve next summary node
          // @summaryId {integer}:
          //    is the current node ID
          // @answerId {integer}:
          //    is the chosen answer ID
          var vm = this;
          for (var i = 0; i < vm.config.answers.length; i++) {
            vm.config.answers[i].disabled = true;
          }
          vm.hasInfo = false;
          setTimeout(function () {
            vm.makeNextCall(summaryId, answerId, function () {
              vm.updateParentProps();
            })
          }, 350);
        }
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
      if (vm.config.info) {
        vm.hasBox = true;
      }
      setTimeout(function () {
        vm.checkIfOverflow();
      }, 1000);
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/summary/Summary.vue